<template>
    <TprmModal
        open
        :title="title"
        size="md"
        allow-close
        @close="$emit('abort')"
    >
        <ul class="ViewEntityPropertyChangedProcedure__list">
            <li v-for="label in changedPropertiesDisplayNames" :key="label">
                {{ label }}
            </li>
        </ul>
        <template #footer>
            <NewButton variant="outline" color="neutral" @click="$emit('abort')">
                Close
            </NewButton>
        </template>
    </TprmModal>
</template>

<style lang="scss">
    .ViewEntityPropertyChangedProcedure__list {
        margin: 0;
        padding-left: 20px;
    }
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';
    import { formatEntityPropertyChangedSummary } from '@/modules/entity-events/utils/formatEntityPropertyChangedSummary';

    // PRODUCT-26110 master-drift: declares the `abort` event this procedure component
    // `$emit`s -- without a declared `emits`, Vue 3 warns "Component emitted event 'abort'
    // but it is neither declared in the emits option nor as an 'onAbort' prop" every time
    // it fires (see ViewNotificationDetailProcedure.vue).
    export default defineComponent({
        name: 'ViewEntityPropertyChangedProcedure',
        components: { TprmModal, NewButton },
        props: {
            // PRODUCT-26110 master-drift: `uuid` is unused; declared purely so Vue 3 doesn't
            // warn "Extraneous non-props attributes (uuid)" -- ProcedureTarget.vue passes
            // `:uuid="execution.uuid"` to every procedure component (see
            // UploadEntityDocumentProcedure.vue / ViewNotificationDetailProcedure.vue).
            uuid: {
                type: String,
                default: '',
            },
            changedPropertiesDisplayNames: {
                type: Array as PropType<string[]>,
                required: true,
            },
        },
        emits: [ 'abort' ],
        computed: {
            title(): string {
                return formatEntityPropertyChangedSummary(this.changedPropertiesDisplayNames);
            },
        },
    });
</script>
